export default (params) => ({
  trigger: {
    name: 'insurance_information.read_extended_explanation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'product_page',
          'insurance_information_overlay',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
    nonInt: true,
  },
});
